// Golden-angle hue stepping keeps sequential scene indices visually distinct.
const GOLDEN_ANGLE_DEGREES = 137.508
const colorCache = new Map<number, [number, number, number]>()

export function overlapColorForIndex(index: number): [number, number, number] {
    let color = colorCache.get(index)
    if (!color) {
        const hue = (index * GOLDEN_ANGLE_DEGREES) % 360
        color = hslToRgb(hue, 45, 55)
        colorCache.set(index, color)
    }
    return color
}

function hslToRgb(h: number, s: number, l: number): [number, number, number] {
    const sNorm = s / 100
    const lNorm = l / 100
    const c = (1 - Math.abs(2 * lNorm - 1)) * sNorm
    const x = c * (1 - Math.abs(((h / 60) % 2) - 1))
    const m = lNorm - c / 2

    let [r, g, b] = [0, 0, 0]
    if (h < 60) [r, g, b] = [c, x, 0]
    else if (h < 120) [r, g, b] = [x, c, 0]
    else if (h < 180) [r, g, b] = [0, c, x]
    else if (h < 240) [r, g, b] = [0, x, c]
    else if (h < 300) [r, g, b] = [x, 0, c]
    else [r, g, b] = [c, 0, x]

    return [Math.round((r + m) * 255), Math.round((g + m) * 255), Math.round((b + m) * 255)]
}
